import api from '../services/api';

/**
 * Lädt ein geschütztes Bild und gibt eine Adresse zurück, die ein `<img>` versteht.
 *
 * Nötig, weil `<img src>` keinen Authorization-Header schickt: die Vorschau eines noch nicht
 * freigegebenen Logos steckt hinter einer Rechteprüfung, und genau die wäre mit einer nackten
 * URL umgangen. Also holt Axios die Bytes (mit Token) und wir reichen dem Browser ein Blob.
 *
 * Der Aufrufer muss die Adresse mit [releaseAuthedImage] wieder freigeben, sonst hält der Browser
 * die Bytes bis zum Seitenwechsel fest.
 */
export const loadAuthedImage = async (path: string): Promise<string> => {
  const response = await api.get(path, { responseType: 'blob' });
  return URL.createObjectURL(response.data as Blob);
};

export const releaseAuthedImage = (url: string | null): void => {
  if (url) URL.revokeObjectURL(url);
};
